import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Adriana M.',
    role: 'Suceava',
    text: 'Am ales să îmi mobilez toată casa cu această firmă și sunt extrem de mulțumită! Fiecare piesă de mobilier este perfect adaptată nevoilor mele, iar calitatea este de top. Echipa a fost foarte profesionistă, de la proiectare până la montaj. Mulțumesc pentru tot!',
    rating: 5,
  },
  {
    name: 'Ioana D.',
    role: 'Suceava',
    text: 'M-au impresionat atenția la detalii și comunicarea excelentă pe parcursul proiectului. Am achiziționat un dressing și mobilier pentru dormitor, iar rezultatul este absolut minunat! Recomand cu toată încrederea pentru oricine își dorește mobilier personalizat de calitate.',
    rating: 5,
  },
  {
    name: 'Elena P.',
    role: 'Suceava',
    text: 'Experiența cu această firmă a fost excelentă! Am comandat un set complet pentru bucătărie și living, iar rezultatul este chiar mai frumos decât mi-am imaginat. De asemenea, montajul a fost rapid și fără probleme. Voi reveni cu siguranță pentru alte piese de mobilier. Vă mulțumesc!',
    rating: 5,
  },
  {
    name: 'Marian Galan',
    role: 'Antreprenor, Suceava',
    text: 'Am mobilat întregul birou prin Mobila ta Mob și sunt foarte mulțumit. Birourile, dulapurile și mobilierul de recepție — totul executat impecabil, la timp și cu materiale premium. Recomand cu încredere!',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section data-testid="testimonials-section" className="py-20 lg:py-32 bg-white dark:bg-[#242322]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#A67B5B] mb-4">
            Testimoniale
          </p>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl tracking-tight font-medium text-[#2C2A29] dark:text-[#F0EDE8]">
            Ce spun clienții noștri
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.slice(0, 3).map((t, i) => (
            <TestimonialCard key={i} testimonial={t} index={i} />
          ))}
        </div>
        <div className="mt-8 max-w-xl mx-auto">
          <TestimonialCard testimonial={testimonials[3]} index={3} />
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial, index }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      data-testid={`testimonial-card-${index}`}
      className="border border-[#E3DACB] dark:border-[#3D3A37] rounded-lg p-8 relative"
    >
      <Quote size={32} className="text-[#A67B5B]/20 absolute top-6 right-6" />
      <div className="flex gap-1 mb-4">
        {Array.from({ length: testimonial.rating }).map((_, j) => (
          <Star key={j} size={16} className="fill-[#A67B5B] text-[#A67B5B]" />
        ))}
      </div>
      <p className="text-base leading-relaxed text-[#6B6561] dark:text-[#9B9590] mb-6 italic">
        "{testimonial.text}"
      </p>
      <div>
        <p className="font-['Outfit'] font-medium text-[#2C2A29] dark:text-[#F0EDE8]">{testimonial.name}</p>
        <p className="text-sm text-[#6B6561] dark:text-[#9B9590]">{testimonial.role}</p>
      </div>
    </motion.div>
  );
}
